import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type GSCCredentialsResponse as SchemaGSCCredentialsResponse } from '../schemas/GSCCredentialsResponse';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @description gets state token and client id for Google Search Console
 * @summary gets state token and client id for Google Search Console
 */
export const GetGSCCredentialsContentType = '' as const;
export type GetGSCCredentialsRequest = void;
export type GetGSCCredentialsResponses = LinkCommonErrorResponses & {
    /**
     * @description State token and client id retrieved successfully
     */
    '200': {
        'application/json': SchemaGSCCredentialsResponse;
    };
};
export type GetGSCCredentialsResponseSuccess = GetGSCCredentialsResponses['200']['application/json'];
export type GetGSCCredentialsSearchParams = undefined;
export type GetGSCCredentialsPathParameters = undefined;
export const GetGSCCredentialsUrl = '/gsc/credentials' as const;
export const GetGSCCredentialsMethod = 'GET' as const;
export const getGetGSCCredentialsUrl = (_params?: GetGSCCredentialsPathParameters) => GetGSCCredentialsUrl;
